@let unread = unreadCount();
@let connState = connectionState();

@if (unread === 0) {
  <div class="bell-container">
    <fa-icon [icon]="faBell" size="2x" class="bell-icon"></fa-icon>
  </div>
}

@if (unread > 0) {
  <div class="bell-container" [ngClass]="getAnimationClass(unread)">
    <fa-icon [icon]="faBellOn" size="2x" class="bell-icon"></fa-icon>
    <span class="unread-count" [ngClass]="{ 'low-count': isLowCount(unread) }"
      >{{ unread }}
    </span>
  </div>
}

@if (connState !== connectedState) {
  <span class="absolute text-red-500 top-[-6px] right-0">X</span>
}
